<script setup lang="ts">
import { OrganizationSelector, TypographyWithPrefix } from '@rfc/rfc-components-library'
import ProductionLineDetail from '../../../components/ProductionLineComponents/Detail/ProductionLineDetail.vue'
</script>

<template>
    <ProductionLineDetail>
        <template #detail="props">
            <TypographyWithPrefix
                :prefix="$t('productionLine.model.organization')"
                :label="props?.data?.organization_id"
                boldLabel />
        </template>
        <template #edit="props">
            <OrganizationSelector
                :label="$t('productionLine.model.organization')"
                :organizationId="props.data?.organization_id"
                @select="props.onChange({ organization_id: $event?.id })" />
        </template>
    </ProductionLineDetail>
</template>
